import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  confettiContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    pointerEvents: 'none',
    zIndex: 1000,
    overflow: 'hidden',
  },
}));
